export const objectMethods = {
    typeName: 'Object',
    functions: {},
};
//# sourceMappingURL=object.methods.js.map